import type { DashboardRoute } from "#/types/navigation";
import {
  IconArchive,
  IconBrandProducthunt,
  IconBuildings,
  IconCarCrane,
  IconCylinder,
  IconDeviceMobileCog,
  IconLayoutGrid,
  IconMoped,
  IconNfc,
  IconTemplate,
  IconTicket,
  IconTopologyBus,
} from "@tabler/icons-react";

export const dashboardRoutes: DashboardRoute[] = [
  {
    label: "nav.dashboard",
    icon: IconLayoutGrid,
    href: "/dashboard",
  },
  {
    label: "nav.sites",
    icon: IconBuildings,
    href: "/sites",
  },
  {
    label: "nav.rfidScanners",
    icon: IconDeviceMobileCog,
    href: "/devices",
  },
  {
    label: "nav.rfidTags",
    icon: IconNfc,
    href: "/rfid-tags",
  },
  {
    label: "nav.inventory",
    icon: IconArchive,
    href: "/inventory",
    children: [
      {
        label: "nav.categories",
        icon: IconBrandProducthunt,
        href: "/categories",
      },
      {
        label: "nav.items",
        icon: IconCylinder,
        href: "/items",
      },
      {
        label: "nav.templates",
        icon: IconTemplate,
        href: "/templates",
      },
    ],
  },
  {
    label: "nav.fleetAndLogistics",
    icon: IconArchive,
    href: "/fleet",
    children: [
      {
        label: "nav.vehicleModels",
        icon: IconMoped,
        href: "/models",
      },
      {
        label: "nav.vehicles",
        icon: IconCarCrane,
        href: "/vehicles",
      },
      {
        label: "nav.shipmentLogs",
        icon: IconTopologyBus,
        href: "/logs",
      },
    ],
  },
  {
    label: "nav.ticketManagement",
    icon: IconTicket,
    href: "/ticket-management",
  },
];

export const adminRoutes = [
  {
    label: "nav.clients",
    icon: IconLayoutGrid,
    href: "/clients",
  },
];
